// outline.js v1.2.0 - https://github.com/lindsayevans/outline.js/
// Remove outline when user use mouse, add outline on devices without mouse or/and when user use keyboard

// eslint-disable-next-line
;((document) => {
  const element = document.createElement('style')

  const setCSS = (cssString: string) => {
    element.innerHTML = cssString
  }

  document.getElementsByTagName('head')[0].appendChild(element)

  // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
  document.addEventListener('mousedown', () => {
    setCSS(
      ':focus{outline:0 !important}::-moz-focus-inner{border:0; !important}'
    )
  })

  // Using touch for mobile devices
  document.addEventListener('touchstart', () => {
    setCSS(
      ':focus{outline:0 !important}::-moz-focus-inner{border:0; !important}'
    )
  })

  document.addEventListener('keydown', () => {
    setCSS('')
  })
})(document)
